<template>
    <div class="participant-professions">
        <div v-if="!hasData" class="empty">
            Профессии не добавлены
        </div>
        <div v-else class="content">
            <router-link
                v-for="profession in items"
                :key="profession.id"
                :to="{ name: 'profession-details', params: { professionId: profession.id } }"
                class="item"
            >
                <div class="icon" />
                <div>{{ profession.name }}</div>
            </router-link>
        </div>
    </div>
</template>

<script>
export default {
    name: "ParticipantProfessions",

    props: {
        items: {
            type: Array,
            default: () => [],
        },
    },

    computed: {
        hasData() {
            return this.items && this.items.length;
        },
    },
};
</script>

<style lang="scss" scoped>
@import "~@/styles/rem";

.participant-professions {
    .empty {
        font-family: 'Proxima Nova', sans-serif;
        font-weight: 600;
        font-size: rem(18);
        line-height: rem(26);
        color: #98A0A9;

        @include on-mobile {
            font-size: mrem(16);
            line-height: mrem(24);
        }
    }

    .item {
        display: flex;
        flex-flow: row nowrap;
        justify-content: flex-start;
        align-items: flex-start;
        margin: 0 0 rem(24);
        font-family: 'Proxima Nova', sans-serif;
        font-style: normal;
        font-weight: 600;
        font-size: rem(18);
        line-height: rem(26);
        color: #2A2626;

        @include on-mobile {
            margin: 0 0 mrem(24);
            font-size: mrem(18);
            line-height: mrem(26);
        }

        &:last-of-type {
            margin: 0;
        }

        .icon {
            flex: 0 0 auto;
            width: rem(20);
            height: rem(20);
            margin: 0 rem(8.5) 0 0;
            background: url("~@/assets/images/icons/profession-icon.svg") no-repeat center/contain;

            @include on-mobile {
                width: mrem(20);
                height: mrem(20);
                margin: 0 mrem(8.5) 0 0;
            }
        }
    }
}
</style>